/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../common/currency';
import '../common/common';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "esperanto": {
        "nested": {
          "api": {
            "nested": {
              "CompleteOrCancelRecordedTransactionRequest": {
                "fields": {
                  "paymentId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "desiredStatus": {
                    "type": ".squareup.esperanto.api.CompleteOrCancelRecordedTransactionRequest.DesiredStatus",
                    "id": 2,
                    "rule": "optional"
                  },
                  "totalMoney": {
                    "type": ".squareup.common.Money",
                    "id": 3,
                    "rule": "optional"
                  },
                  "tipMoney": {
                    "type": ".squareup.common.Money",
                    "id": 4,
                    "rule": "optional"
                  },
                  "taxMoney": {
                    "type": ".squareup.common.Money",
                    "id": 8,
                    "rule": "optional"
                  },
                  "completeCashPaymentDetails": {
                    "type": ".squareup.esperanto.api.CompleteCashPaymentDetails",
                    "id": 5,
                    "rule": "optional"
                  },
                  "options": {
                    "type": ".squareup.esperanto.common.ReverseOptions",
                    "id": 7,
                    "rule": "optional"
                  },
                  "isStoreAndForward": {
                    "type": "bool",
                    "id": 9,
                    "rule": "optional"
                  },
                  "billInfo": {
                    "type": ".squareup.esperanto.common.BillInfo",
                    "id": 10,
                    "rule": "optional"
                  },
                  "overrideCompletedOrCanceledAtMs": {
                    "type": "int64",
                    "id": 11,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "DesiredStatus": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "COMPLETED": 1,
                      "CANCELED": 2
                    }
                  }
                }
              },
              "CompleteOrCancelRecordedTransactionResponse": {
                "fields": {
                  "paymentId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "error": {
                    "type": ".squareup.esperanto.api.CompleteOrCancelRecordedTransactionResponse.Error",
                    "id": 2,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Error": {
                    "values": {
                      "DEFAULT_ENUM_DO_NOT_USE": 0,
                      "INVALID_REQUEST": 1,
                      "PAYMENT_NOT_FOUND": 2,
                      "INVALID_TRANSACTION_TYPE": 3,
                      "INVALID_STATE": 4
                    }
                  }
                }
              },
              "CompleteCashPaymentDetails": {
                "fields": {
                  "buyerSuppliedMoney": {
                    "type": ".squareup.common.Money",
                    "id": 1,
                    "rule": "optional"
                  },
                  "changeBackMoney": {
                    "type": ".squareup.common.Money",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.esperanto?.nested?.api?.nested?.CompleteOrCancelRecordedTransactionRequest && !$root.nested?.squareup?.nested?.esperanto?.nested?.api?.nested?.CompleteOrCancelRecordedTransactionRequest?.nested?.DesiredStatus && !$root.nested?.squareup?.nested?.esperanto?.nested?.api?.nested?.CompleteOrCancelRecordedTransactionResponse && !$root.nested?.squareup?.nested?.esperanto?.nested?.api?.nested?.CompleteOrCancelRecordedTransactionResponse?.nested?.Error && !$root.nested?.squareup?.nested?.esperanto?.nested?.api?.nested?.CompleteCashPaymentDetails) {
  $root.addJSON(jsonData);
}

/**
 * Request payload for updating the state of a RecordedTransaction to a terminal state
 * (COMPLETED or CANCELED) -- Can only be updated if the current status is CREATED.
 *
 * SOURCE CompleteOrCancelRecordedTransactionRequest @ squareup/esperanto/api/complete_or_cancel_recorded.proto at 15:1
 */
export const CompleteOrCancelRecordedTransactionRequest = $root.lookupType('squareup.esperanto.api.CompleteOrCancelRecordedTransactionRequest');
fixType(CompleteOrCancelRecordedTransactionRequest, {
  paymentId: {
    required: true
  },
  desiredStatus: {
    required: true
  }
});
Builder.createAndAttachToType(CompleteOrCancelRecordedTransactionRequest);
/**
 * The desired status of the RecordedTransaction. The status can only be updated if the current
 * status is CREATED.
 *
 * SOURCE DesiredStatus @ squareup/esperanto/api/complete_or_cancel_recorded.proto at 23:3
 */
CompleteOrCancelRecordedTransactionRequest.DesiredStatus = $root.lookupEnum('squareup.esperanto.api.CompleteOrCancelRecordedTransactionRequest.DesiredStatus').values;
/**
 * Response payload for completing or canceling a recorded transaction.
 *
 * SOURCE CompleteOrCancelRecordedTransactionResponse @ squareup/esperanto/api/complete_or_cancel_recorded.proto at 81:1
 */
export const CompleteOrCancelRecordedTransactionResponse = $root.lookupType('squareup.esperanto.api.CompleteOrCancelRecordedTransactionResponse');
fixType(CompleteOrCancelRecordedTransactionResponse);
Builder.createAndAttachToType(CompleteOrCancelRecordedTransactionResponse);
/**
 * SOURCE Error @ squareup/esperanto/api/complete_or_cancel_recorded.proto at 85:3
 */
CompleteOrCancelRecordedTransactionResponse.Error = $root.lookupEnum('squareup.esperanto.api.CompleteOrCancelRecordedTransactionResponse.Error').values;
/**
 * SOURCE CompleteCashPaymentDetails @ squareup/esperanto/api/complete_or_cancel_recorded.proto at 105:1
 */
export const CompleteCashPaymentDetails = $root.lookupType('squareup.esperanto.api.CompleteCashPaymentDetails');
fixType(CompleteCashPaymentDetails);
Builder.createAndAttachToType(CompleteCashPaymentDetails);